export default __webpack_public_path__ + "static/media/pic2.85191d56.jpg";